export const TRACK_USER = 'TRACK_USER';

export const trackUser = (data) => ({
  type: TRACK_USER,
  payload: data
});